import $ from 'jquery'

export default {
    name: 'assure-consultations',
    components: {},
    props: {
        list_exclu_consultations: Array
    },
    data() {
        return {
            select_all: '',
            checked_consult: [],
            all_checked: false,
            one_is_checked: [],
            text_grey: []
        }
    },

    watch: {
        one_is_checked() {
            this.$store.commit('SET_EXCLU_CONSULTATION', this.one_is_checked)
        }
    },

    computed: {
        list_consultations() {
            return this.$store.getters["list_consultations"];
        },
    },

    mounted() {
        this.listTypeConsultations()
    },

    methods: {
        listTypeConsultations() {
            this.$store.dispatch("getTousTypeConsultations").then(() => {
                if (this.list_consultations.length > 0) {
                    this.setSelectedTypeConsultations()
                }
            }).then(() => { this.$store.commit('SET_EXCLU_CONSULTATION', this.one_is_checked); this.$emit('pret') }).catch(() => { this.$emit('erreur') })
        },

        setSelectedTypeConsultations() {
            this.one_is_checked = []
            this.text_grey = []

            this.list_exclu_consultations.forEach(exclusion => {
                this.list_consultations.forEach(type_consultation => {
                    if (exclusion.id == type_consultation.id) {
                        this.text_grey[type_consultation.id] = 'text-grey'
                        this.one_is_checked.push(type_consultation.id)
                    }
                });
            });
        },

        toutSelectionner() {
            let is_checked = $('#consult-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                this.list_consultations.forEach((type_consultation) => {
                    this.text_grey[type_consultation.id] = 'text-grey'
                    this.one_is_checked.push(type_consultation.id)
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false

                this.list_consultations.forEach((type_consultation) => {
                    this.text_grey[type_consultation.id] = ''
                });
            }
        },

        onExclu(index) {
            let is_checked = $('#consult'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c
        },
    }
}


